import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import ReportsSection from './ReportsSection';
import GestionSection from './GestionSection';
import ClientesSection from './ClientesSection';
import AtencionSection from './AtencionSection';
import ExternalTransfersSection from './ExternalTransfersSection';
import MtCenterTransactionsSection from './MtCenterTransactionsSection';
import TasasInteresSection from './TasasInteresSection';
import SegurosSection from './SegurosSection';

interface DashboardProps {
  onLogout: () => void;
}

const Dashboard: React.FC<DashboardProps> = ({ onLogout }) => {
  const [activeSection, setActiveSection] = useState('reportes');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const renderContent = () => {
    switch (activeSection) {
      case 'reportes':
        return <ReportsSection />;
      case 'gestion':
        return <GestionSection />;
      case 'clientes':
        return <ClientesSection />;
      case 'atencion':
        return <AtencionSection />;
      case 'transferencias':
        return <ExternalTransfersSection />;
      case 'mt-center':
        return <MtCenterTransactionsSection />;
      case 'tasas':
        return <TasasInteresSection />;
      case 'seguros':
        return <SegurosSection />;
      default:
        return <ReportsSection />;
    }
  };

  return (
    <div className="flex h-screen bg-secondary-50">
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      
      {/* Sidebar */}
      <div className={`
        fixed lg:static inset-y-0 left-0 z-50 w-64 bg-white shadow-soft transform transition-transform duration-300 ease-in-out
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        <Sidebar 
          activeSection={activeSection} 
          onSectionChange={(section) => {
            setActiveSection(section);
            setSidebarOpen(false); // Close sidebar on mobile after selection
          }}
          onClose={() => setSidebarOpen(false)}
          onLogout={onLogout}
        />
      </div>
      
      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Mobile header */}
        <div className="lg:hidden bg-white border-b border-secondary-200 px-4 py-3 flex items-center justify-between">
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-2 rounded-lg text-secondary-600 hover:bg-secondary-100"
          >
            <Menu className="h-6 w-6" />
          </button>
          <h1 className="text-lg font-semibold text-secondary-900">CENTAdmin</h1>
          <div className="w-10" /> {/* Spacer for centering */}
        </div>
        
        {/* Content area */}
        <div className="flex-1 overflow-auto">
          <div className="p-4 lg:p-6">
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};



export default Dashboard;
